import axiosInstance from '../../Api/axiosInstance';

const API_URL = '/crm/leads';

// Get all leads for a company
export const getLeads = async (companyId) => {
	try {
		const response = await axiosInstance.get(API_URL, {
			params: { companyId },
		});
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.msg || 'Error fetching leads.');
	}
};

// Get a specific lead by ID
export const getLeadById = async (leadId, companyId) => {
	try {
		const response = await axiosInstance.get(`${API_URL}/${leadId}`, {
			params: { companyId },
		});
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.msg || 'Error fetching lead.');
	}
};

// Create a new lead
export const createLead = async (leadData, companyId) => {
	try {
		const response = await axiosInstance.post(API_URL, leadData, {
			params: { companyId },
		});
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.msg || 'Error creating lead.');
	}
};

// Update an existing lead
export const updateLead = async (leadId, leadData, companyId) => {
	try {
		const response = await axiosInstance.put(`${API_URL}/${leadId}`, leadData, {
			params: { companyId },
		});
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.msg || 'Error updating lead.');
	}
};

// Delete a lead
export const deleteLead = async (leadId, companyId) => {
	try {
		const response = await axiosInstance.delete(`${API_URL}/${leadId}`, {
			params: { companyId },
		});
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.msg || 'Error deleting lead.');
	}
};
